/**
 * @Action: 大屏相关路由
 * @Author: Maple
 * @UpDate: 2026/1/5
 */

export default [
  // 多电站大屏
  {
    path: '/largeScreen',
    name: 'LargeScreen',
    children: [
      {
        path: 'stationsMultiple',
        name: 'StationsMultiple',
        component: () => import('@/views/largeScreen/stationsMultiple/index.vue'),
        meta: {
          title: 'v2_router_label23',
        }
      },
      {
        path: 'setConfig',
        name: 'SetConfig',
        component: () => import('@/views/largeScreen/setConfig/index.vue'),
        meta: {
          title: 'v2_dashboard_setting',
        }
      }
    ]
  }
]
